import { useState, useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const useFormValidationSignup = () => {
  const {  userType} = useContext(AuthContext);
  const navigate = useNavigate();

  const defaultFormData = {
    email: "",
    password: "",
    confirmPassword: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [errors, setErrors] = useState({});
  const [resDataError, setResDataError] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const setSessionStorageWithExpiry = (key, value, expiryTime) => {
    const data = {
      value,
      expiry: new Date().getTime() + expiryTime,
    };
    sessionStorage.setItem(key, JSON.stringify(data));
  };


  // Store email and password in session storage
  const expiryTime = 300000; // 5 minutes
  setSessionStorageWithExpiry("userEmail", formData.email, expiryTime);
  setSessionStorageWithExpiry("userPassword", formData.password, expiryTime);

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    const errors = [];

    if (password.length < 6) {
      errors.push("Password must be at least 6 characters long");
    }

    return errors.length === 0 ? null : errors;
  };

  const validateConfirmPassword = (confirmPassword) => {
    if (confirmPassword !== formData.password) {
      return "Passwords do not match";
    }
    return null;
  };

  const handleInputChange = (e) => {
    setErrors({});
    setResDataError(null);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleShow = () => {
    setShow(!show);
  };
  const handleShow2 = () => {
    setShow2(!show2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    const passwordErrors = validatePassword(formData.password);
    if (passwordErrors) {
      newErrors.password = passwordErrors;
    }

    const confirmPasswordError = validateConfirmPassword(formData.confirmPassword);
    if (confirmPasswordError) {
      newErrors.confirmPassword = confirmPasswordError;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);

      try {
        let endpoint = "";

       
        if (userType === "Charterer") {
          endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/signup/charterer`;
        } else if (userType === "Vessel Owner") {
          endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/signup/vesselOwner`;
        }

        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const resData = await res.json();

        if (!res.ok) {
          setResDataError(resData.message);
          throw new Error(resData.message);
        }  else {
          navigate("/AccountVerification");
        } 
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return {
    formData,
    errors,
    resDataError,
    isLoading,
    handleInputChange,
    handleSubmit,
    handleShow,
    show,
    handleShow2,
    show2
  };
};

export default useFormValidationSignup;
